import { Helmet } from 'react-helmet-async';
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { useEffect } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Button } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
import Iconify from '../components/iconify';
// sections
import { ForgotPasswordForm } from '../sections/auth/forgotPassword';

import { supabase } from "../services/supabase";
import { useAuth } from "../contexts/auth"


// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function ResetPasswordPage() {
  const mdUp = useResponsive('up', 'md');

  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/app")
    }
  }, [navigate, user]);

  return (
    <>
      <Helmet>
        <title> Forgot Password | Flastchat </title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        <Container maxWidth="sm">
          <StyledContent>
            <Typography variant="h4" gutterBottom sx={{ mb: 5 }}>
              Forgot your password?
            </Typography>

            <Typography variant="body2" sx={{ mb: 5 }}>
              Enter your email address and we'll send you a link to reset your password.
            </Typography>

            <ForgotPasswordForm />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
